<template>
  <div>
    <div class="header">
      <NavBar></NavBar>
      <div class="title">
        <div>{{ $t("message.AboutUs") }}</div>
      </div>
    </div>
    <Card>
      <template v-slot:title> 公司介绍 </template>
      <template v-slot:body>
        <div class="CompanyProfile">
          <div class="head">上海奕盛软件有限公司</div>
          <div class="foot">
            <img src="@/assets/img/juxing18.png" />
            <div class="right">
              <div class="tit">卓越创新</div>
              <p class="twofloor">
                自2000年创建以来,以坚韧的努力和追求卓越的精神不断创新，致力于为中国地区的制造商提供完整的企业管理及IT解决方案帮助打造高效企业迎接全球化发展带来的挑战，并以优良的技术和完美的服务，赢得众多外资与本地客户的信赖。我们高度关注汽车、生命科学、电子、食品饮料和消费品等垂直行业的发展并基于信息简单、自动化等原则协助该行业领域内的制造商
              </p>
              <div class="tit">高效管理</div>
              <div
                v-for="(item, index) in CompanyProfile"
                :key="index"
                class="list"
              >
                <img src="@/assets/img/juxin19.png" />
                <div>{{ item }}</div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:title>关于我们</template>
      <template v-slot:body>
          <div style="display: flex; justify-content: center;">
          <img src="@/assets/img/ESUN_SITE.png" style="width: 80%; margin: 3rem 0" @click="toBaiduEsunSite()">
        </div>
        <!-- <div
          id="container"
          style="width: 100%; height: 40rem; margin: 3rem 0"
        ></div> -->
        <div class="addr">
          <el-row style="margin-bottom: 20px">
            <el-col :span="4" style="text-align: center; font-weight: 600"
              >公司地点</el-col
            >
            <el-col :span="20" style="text-align: left"
              >上海市闵行区浦江镇联航路1588号国家现代服务业软件产业基地SOHO研发楼第8幢</el-col
            >
          </el-row>
          <el-row style="margin-bottom: 20px">
            <el-col :span="4" style="text-align: center; font-weight: 600"
              >联系我们</el-col
            >
            <el-col :span="20" style="text-align: left">021-53015840</el-col>
          </el-row>
          <el-row>
            <el-col :span="4" style="text-align: center; font-weight: 600"
              >&nbsp;</el-col
            >
            <el-col :span="20" style="text-align: left"
              >sales@esun.sh.cn support@esun.sh.cn</el-col
            >
          </el-row>
        </div>
      </template>
    </Card>
    <Footer></Footer>
  </div>
</template>
    
    <script>
import NavBar from "@/components/NavBar.vue";
import Footer from "@/components/Footer.vue";
import Au from "@/assets/img/Au.png";
import logo1 from "@/assets/img/logo1.png";
import ccc from "@/assets/img/ccc.png";
import Card from "@/components/Card.vue";

export default {
  components: {
    NavBar,
    Footer,
    Card,
  },
  data() {
    return {
      CompanyProfile: [
        "协同、合规与自动化供应链管理",
        "质量＝生命",
        "面向效率与合规的财务管理",
        "自动化业务流程管理",
      ],
    };
  },
  methods:{
    toBaiduEsunSite(){
        window.open("https://map.baidu.com/search/%E4%B8%8A%E6%B5%B7%E5%A5%95%E7%9B%9B%E8%BD%AF%E4%BB%B6%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/@13527877,3621420,18z?querytype=s&da_src=shareurl&wd=%E4%B8%8A%E6%B5%B7%E5%A5%95%E7%9B%9B%E8%BD%AF%E4%BB%B6%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&c=289&src=0&wd2=%E4%B8%8A%E6%B5%B7%E5%B8%82%E9%97%B5%E8%A1%8C%E5%8C%BA&pn=0&sug=1&l=13&b=(13506375,3612771;13555527,3636131)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&sug_forward=735551faf714a5d8c5effbaa&device_ratio=2"); // 新标签页打开目标URL
    },
    mapInit() {
      // 2. 创建地图示例
     
    },
  },
  mounted() {
    // this.mapInit();
  },
};
</script>
    
  <style lang="scss" scoped>
.header {
  background-image: url("@/assets/img/you-x-ventures-X8H8vPcelPk-unsplash (2).png");
  background-position-y: -155px;
  height: 327px;
  position: relative;
  width: 100%;
  .title {
    height: 100%;
    background-color: #232585;
    opacity: 0.8;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 3rem;
    > div {
      font-family: DingTalk JinBuTi;
    }
  }
}
</style>